
import { Link } from 'react-router-dom';
import videos from "./data.json"



const AllVideos = () => {


    return (  
        <div className="allvideos">
            <h1>All Videos</h1>


            {videos && videos.map((video) => (
                <div className="repo-preview" key={video.id}>
                    <Link to={`/allvideos/${video.id}`}>
                    <h2>{video.title}</h2>
                    </Link>

                </div>
            ))}
        </div>
    );

}

export default AllVideos;